export enum HttpStatus {
  OK = 200,
  NO_CONTENT = 204,
  NOT_FOUND = 404,
  INTERNAL_SERVER_ERROR = 500,
  NOT_IMPLEMENTED = 501,
  BAD_GATEWAY = 502
}

export enum ValidationRules {
  MIN_NAME_LENGTH = 3,
  MAX_NAME_LENGTH = 50,
  MIN_REQUIREMENTS_LENGTH = 50,
  MAX_REQUIREMENTS_LENGTH = 500
}

export const Language = {
  RU: 'ru',
  EN: 'en'
};

export const FileType = {
  RU_PPT: 'RU_PPT',
  EN_PPT: 'EN_PPT',
  RU_PPT1: 'RU_PPT1',
  EN_PPT1: 'EN_PPT1',
  RU_PPT2: 'RU_PPT2',
  EN_PPT2: 'EN_PPT2'
};

export const LevelNumber = {
  LEVEL_1: 1,
  LEVEL_2: 2,
  LEVEL_3: 3,
  LEVEL_4: 4,
  LEVEL_5: 5
};

export const FileIndex = {
  FIRST: 0,
  SECOND: 1
};

export const ModalResult = {
  OK: 'ok'
};

export const NO_POSITION = 'No position';

export const VALIDATION_PATTERN = /^[a-zA-Zа-яА-ЯёЁ0-9\u4e00-\u9fff\s\-_.,()]+$/;

export const ROUTES = {
  SPECIALIZATIONS_LIST: '/dashboard/specializations-list'
};

export const ARRAY_INDEX = {
  FIRST: 0,
  SECOND: 1,
  THIRD: 2,
  LAST: -1
};

export const ANSWER_COUNT = 3;

export const EXTRA_SPACES_PATTERN = / {2,}$/;



// WEBPACK FOOTER //
// C:/work/new2/internal-frontend/src/app/content-page/common/specializations/constants/specializations.constants.ts